import {useIntl} from "react-intl";
import {Table, usePopup} from "../../UIElements";
import React, {useState} from "react";
import {useSupportBotContext} from "./SupportBotData";
import {getNameWithAnnieUser} from "../../DataFunctions";

const BotCoordinatorSelector = ({id, value, onChange}) => {
    const intl = useIntl()
    const { showPopup } = usePopup()
    const { data: { users } } = useSupportBotContext()

    return <button className={"add-new-button"} id={id} onClick={() => {showPopup(<BotCoordinatorPicker onChange={onChange} value={value} users={users} />, 'max-width')}}>
        + {getNameWithAnnieUser(users, value) || intl.formatMessage(
            {
                id: 'selectUser',
                defaultMessage: 'Select user',
            })}
    </button>
}

const BotCoordinatorPicker = ({onChange, value, users}) => {
    const intl = useIntl()
    const {hidePopup} = usePopup()
    const [selectedCoordinator, setSelectedCoordinator] = useState(value ? [value] : [])

    const columns = React.useMemo(()=>[
        {
            Header: () => (
                <span>
                    {intl.formatMessage({
                        defaultMessage:'Email',
                        id:'email'
                    })}
                    <i> {intl.formatMessage({
                        defaultMessage:'or id',
                        id:'orId'
                    })}</i>
                </span>
            ),
            accessor: 'meta.email',
            Cell: ({ cell: { value }, row: { original } }) => {
                if (value) {
                    return value
                } else {
                    return <i>{original?.meta?.userid || original?.id}</i>
                }
            },
        },
        {
            Header: intl.formatMessage({defaultMessage:'Name',id:'name'}),
            id: 'name',
            accessor: row => `${row.meta.firstname || ''} ${row.meta.lastname || ''}`.trim(),
        },
        {
            Header: intl.formatMessage({defaultMessage:'Role',id:'role'}),
            accessor: 'meta.role',
        },
        {
            Header: intl.formatMessage({defaultMessage:'Aliases',id:'aliases'}),
            accessor: 'meta.aliases',
            Cell: ({value}) => {
                if (value === null || value === undefined) {
                    return ''
                }

                return value.map((user, i) => (
                    <React.Fragment key={i}>
                        {user}{i < value.length - 1 ? ', ' : ''}
                        {i < value.length - 1 && <br />}
                    </React.Fragment>
                ))
            }
        },
    ],[])
    const globalSearchPlaceholder = intl.formatMessage({id:'searchSupportProviders.placeholder', defaultMessage:'Search support providers'})

    const confirmProviderEdit = () => {
        onChange(selectedCoordinator[0])
        hidePopup()
    }

    const handleProviderUpdate = (id,state) => {
        if (state) {
            setSelectedCoordinator([id])
        }
    }

    return <div className={"provider-selection"}>
        <h1>
            {intl.formatMessage({
                defaultMessage: "Select bot coordinator",
                id: "selectBotCoordinator"
            })}
        </h1>
        <Table columns={columns}
            data={users}
            globalSearchPlaceholder={globalSearchPlaceholder}
            initialSelections={selectedCoordinator}
            updateSelectedProviders={(id, state)=>handleProviderUpdate(id, state)} />
        <div className={"modal-options"}>
            <div>
                <button className={"cancel"} onClick={() => hidePopup()}>
                    {intl.formatMessage(
                        {
                            id: 'modal.cancel',
                            defaultMessage: 'Cancel',
                        })}
                </button>
                <button onClick={() => confirmProviderEdit()} className={"confirm"}>
                    {intl.formatMessage(
                        {
                            id: 'select',
                            defaultMessage: 'Select',
                        })}
                </button>
            </div>
        </div>
    </div>
}
export default BotCoordinatorSelector